/** Route → dynamic import for campaign workspace chunks (hover prefetch). */
const HUB_PREFETCHERS = {
  '/campaigns/portfolios': () => import('../pages/advertising/Portfolios'),
  '/campaigns/list': () => import('../pages/Campaigns'),
  '/campaigns/drafts': () => import('../pages/advertising/Drafts'),
  '/campaigns/targeting-library': () => import('../pages/advertising/TargetingLibrary'),
  '/campaigns/keywords': () => import('../pages/Keywords'),
  '/products': () => import('../pages/Products'),
  '/campaigns/budgets': () => import('../pages/advertising/Budgets'),
  '/automation/amazon': () => import('../pages/advertising/AmazonRules'),
  '/campaigns/history': () => import('../pages/advertising/History'),
  '/campaigns/bulk': () => import('../pages/BulkOperations'),
  '/campaigns/settings': () => import('../pages/advertising/AdvertisingSettings'),
};

const prefetched = new Set();

export function prefetchCampaignHubRoute(path) {
  const key = path?.split('?')[0];
  if (!key || prefetched.has(key)) return;
  const load = HUB_PREFETCHERS[key];
  if (!load) return;
  prefetched.add(key);
  load().catch(() => {
    prefetched.delete(key);
  });
}
